/** Vercel project names: lowercase, only `[a-z0-9._-]`, no leading/trailing separators, max 100 chars. */
export function sanitizeVercelProjectName(name: string): string {
  const cleaned = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/^[-_.]+/, '')
    .replace(/[-_.]+$/, '')
    .slice(0, 100)
  return cleaned || 'my-app'
}
